module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html
 ** module id = 507
 ** module chunks = 1
 **/